angular.module('forms').directive('apSetFocusEvent',
    ['$timeout', '$window',
        function ($timeout, $window) {
            'use strict';

            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    element.on(attrs.apSetFocusEvent, function () {
                        setFocus(attrs.apSetFocusId);
                    });

                    scope.$on('$destroy', function () {
                        element.off(attrs.apSetFocusEvent);
                    });

                    function setFocus(id) {
                        $timeout(function () {
                            var element = $window.document.getElementById(id);
                            if (element) {
                                element.focus();
                                /*
                                 if (element.setSelectionRange) {
                                    element.setSelectionRange(0, 0);
                                 } else if (element.createTextRange) {
                                     var range = element.createTextRange();
                                     range.moveStart('character', 0);
                                     range.select();
                                 }
                                 */
                            }
                        });
                    }
                }
            };
        }
    ]
);